import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Core_Escrow_Release_Request_S.css';

const Core_Escrow_Release_Request_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Core Escrow Release Request');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/Core_Escrow_Release_Request', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/Core_Escrow_Release_Request',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [CORE_ESCROW_RELEASE_REQUEST, setCORE_ESCROW_RELEASE_REQUEST] = React.useState(null);
  const [CORE_ESCROW_RELEASE_REQUEST_S, setCORE_ESCROW_RELEASE_REQUEST_S] = React.useState(null);

  var Ids = [];
  for(var Ele in CORE_ESCROW_RELEASE_REQUEST_S){
	  for(var Sec in CORE_ESCROW_RELEASE_REQUEST_S[Ele]){
			if(Sec == "id")
				Ids.push(CORE_ESCROW_RELEASE_REQUEST_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(CORE_ESCROW_RELEASE_REQUEST_S[Ele]["status"]);
			else if(Array.isArray(CORE_ESCROW_RELEASE_REQUEST_S[Ele][Sec]))
				  for(var Row in CORE_ESCROW_RELEASE_REQUEST_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in CORE_ESCROW_RELEASE_REQUEST_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST`).then((response) => {
      setCORE_ESCROW_RELEASE_REQUEST(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setCORE_ESCROW_RELEASE_REQUEST_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!CORE_ESCROW_RELEASE_REQUEST_S) return <div>Loading...</div>;

 const handleLastDataCORE_ESCROW_RELEASE_REQUEST_S = async (data) => {
  };




  const handleAddCORE_ESCROW_RELEASE_REQUEST_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST_S', JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_ESCROW_RELEASE_REQUEST_S');
      setCORE_ESCROW_RELEASE_REQUEST_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["4"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"]=value;
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["5"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("5","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST(Temp_Data);
	//handleAddCORE_ESCROW_RELEASE_REQUEST(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_ESCROW_RELEASE_REQUEST_S));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"]=value;
	//handleAddCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data,App_Data['CORE_ESCROW_RELEASE_REQUEST_S']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4",value,Temp_Data);
 	//handleLastDataCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
    setCORE_ESCROW_RELEASE_REQUEST_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = CORE_ESCROW_RELEASE_REQUEST_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Core Escrow Release Request')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Release Request ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0" type="text" className="form-control" placeholder="Escrow Release Request ID"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Release Request ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Account ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1" type="text" className="form-control" placeholder="Escrow Account ID"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Account ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2" type="text" className="form-control" placeholder="Offering ID"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3" type="text" className="form-control" placeholder="Milestone ID"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Milestone ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0" type="text" className="form-control" placeholder="Requested Amount USD"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Requested Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1" type="text" className="form-control" placeholder="Requested By"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Requested By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Request Reason`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0" type="text" className="form-control" placeholder="Request Reason"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Request Reason`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Supporting Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1" type="text" className="form-control" placeholder="Supporting Document Link"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Supporting Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Release Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"   onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0_Change} className="form-control" name="Release Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Requested">Requested</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Released">Released</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Release Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"   onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"   onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Escrow Release Request ID`)}</th>
                        <th>{t(`Escrow Account ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Milestone ID`)}</th>
                        <th>{t(`Requested Amount USD`)}</th>
                        <th>{t(`Requested By`)}</th>
                        <th>{t(`Request Reason`)}</th>
                        <th>{t(`Supporting Document Link`)}</th>
                        <th>{t(`Release Status`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_ESCROW_RELEASE_REQUEST_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_1"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_2"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_1_3"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_2_1"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_3_1"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_4_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_1"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_2"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_3"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_4"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_5_5"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_0"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_1"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_2"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_3"]} </td>
						<td>{e["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_ESCROW_RELEASE_REQUEST_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default Core_Escrow_Release_Request_S;  